import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { nf } from "@/lib/format";
import { L } from "@/i18n";
import { Panel } from "./Panel";
import { ChartTooltip } from "./ChartTooltip";

export const ModuleChart = ({ modules, total }) => (
  <Panel
    testId="chart-module-distribution"
    className="lg:col-span-8"
    title={L("Questions by module", "Perguntas por módulo")}
    subtitle={L("{n} questions in the catalog · M1 to M17", "{n} perguntas no catálogo · M1 a M17", { n: nf.format(total) })}
  >
    <div className="h-72">
      <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 600, height: 288 }}>
        <BarChart data={modules} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
          <defs>
            <linearGradient id="amberBar" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#f59e0b" stopOpacity={1} />
              <stop offset="100%" stopColor="#f59e0b" stopOpacity={0.35} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#1e293b" vertical={false} />
          <XAxis dataKey="id" tick={{ fill: "#94a3b8", fontSize: 11, fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} interval={0} />
          <YAxis tick={{ fill: "#64748b", fontSize: 11 }} axisLine={false} tickLine={false} />
          <Tooltip content={<ChartTooltip unit={L("questions", "perguntas")} />} cursor={{ fill: "rgba(245,158,11,0.06)" }} />
          <Bar dataKey="count" fill="url(#amberBar)" radius={[3, 3, 0, 0]} maxBarSize={36} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </Panel>
);
